<template>
    <div>
        <el-dropdown ref="notification-icon" class="notification-dropdown-container" trigger="click" @command="handleCommand" @visible-change="visibleChange">
            <span class="el-dropdown-link">
                <div class="notification-icon-wrapper">
                    <el-badge :hidden="isBadge" :value="displayUnreadNotificationCount" class="item badge-item">
                        <i class="el-icon-message-solid" />
                    </el-badge>
                </div>
            </span>
            <el-dropdown-menu slot="dropdown" class="notification-dropdown-menu" :style="'max-height:' + screenHeight + 'px' ">
                <notification-header @readAllNotification="readAllNotification" @handleClickSetttings="handleClickSetttings" />
                <el-dropdown-item v-for="(message, index) in userNotifications" :key="'notification' + index" :command="message" class="clearfix notification-dropdown">
                    <notification-message-item :message="message" />
                </el-dropdown-item>
                <p v-if="userNotifications && userNotifications.length == 0" class="empty-notifications">- No notifications found -</p>
                <p v-if="isShowMore" class="get-more-text" @click="getMoreNotification">More</p>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import NotificationMessageItem from "./NotificationMessageItem";
import NotificationHeader from "./NotificationHeader";
import { mapGetters } from "vuex";

export default {
    components: {
        "notification-message-item": NotificationMessageItem,
        "notification-header": NotificationHeader,
    },
    data() {
        return {
            notifications: null,
            isHidden: false,
            screenHeight: 500,
            noNotifications: [],

            SkipCount: 0,
            MaxResultCount: 20,
        };
    },
    computed: {
        isBadge() {
            if (this.displayUnreadNotificationCount > 0) return false;
            else return true;
        },
        isShowMore() {
            if (this.userNotifications && this.userNotifications.length > 0 && this.totalNotificationCount) {
                // return this.totalNotificationCount > this.userNotifications?.length ? true : false
            }
        },
        notificationPagination() {
            return {
                "SkipCount": this.SkipCount,
                "MaxResultCount": this.MaxResultCount
            };
        },
        ...mapGetters([
            "userNotifications",
            "totalNotificationCount",
            "unreadNotificationCount",
            "displayUnreadNotificationCount",
        ]),
    },
    watch: {
        displayUnreadNotificationCount() {
            this.$store.dispatch("signalr/updatePageTitle", this.displayUnreadNotificationCount);
        }
    },
    async mounted() {
        this.getNotifications();
        this.$nextTick(() => {
            this.getScreenHeight();
        });
    },
    methods: {
        handleClickSetttings() {
            this.$refs["notification-icon"].visible = false;
        },
        visibleChange(visible) {
            if (visible == true) {
                this.$store.dispatch("signalr/setDisplayUnreadCount", 0);
            }
        },
        async readNotification(message) {
            this.$store.dispatch("signalr/setNotificationAsRead", message.id);
        },
        async handleCommand(message) {
            if (message.state == 0) this.readNotification(message);
            // console.log('click', message)
            var { Category } = message.notification.data.properties;
            switch (Category) {
            case "TRIAL":
                var { TrialId } = message.notification.data.properties;
                this.$_navigateTo({ name: "TrialDetail",params: { "id": TrialId } });
                break;
            case "IMPORT":
                this.$_navigateTo({ name: "ImportStatus" });
                break;
            default:
                break;
            }
        },

        async getMoreNotification() {
            this.SkipCount = this.SkipCount + this.MaxResultCount;
            this.$store.dispatch("signalr/getMoreNotifications", this.notificationPagination);
        },
        getNotifications() {
            this.$store.dispatch("signalr/getAllNotifications", this.notificationPagination);
        },
        async readAllNotification() {
            this.$store.dispatch("signalr/setAllNotificationsAsRead", this.notificationPagination);
        },
        getScreenHeight() {
            this.screenHeight = window.innerHeight - 300;
        }
    }
};
</script>

<style>
.notification-icon-wrapper {
    font-size: 20px;
    color: var(--sidebar-logo-container);
    margin: 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    border-radius: 50%;
    cursor: pointer;
    width: 32px;
    height: 32px;
}

.badge-item .el-badge__content{
    font-size: 11px !important;
    line-height: 17px !important;
    padding: 0 5px !important;
}
.notification-dropdown-menu .el-dropdown-menu__item {
    padding: 0 !important;
}
.notification-dropdown-menu {
    overflow: auto !important;
}
.notification-dropdown-menu::-webkit-scrollbar
{
    width: 3px;
    height: 5px;
    background-color: #F5F5F5;
}
.notification-dropdown-menu::-webkit-scrollbar-track
{
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
}
.get-more-text {
    text-align: center;
    padding-top: var(--space-4);
}
.get-more-text:hover {
    cursor: pointer;
    text-decoration: underline;
}
.empty-notifications {
    width: 320px;
    text-align: center;
    padding: 16px 12px;
    color: var(--description-grey);
}
</style>


// WEBPACK FOOTER //
// src/components/Notification/NotificationIcon.vue